import React, { useEffect, useState } from 'react';
import CircleButton, { getCircleButtonClass, } from 'components/v2/buttons/CircleButton';
import { ClipboardCheck } from 'lucide-react';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import ConfirmationModal from 'components/modules/shipments/accessorials/ConfirmationModal';
import { getAccessorialRequests } from 'utils/AccessorialRequestWebAPIUtils';
import AccessorialRequestActionCreators from 'actions/AccessorialRequestActionCreators';
const fscAccessorialTypes = [
    'fuel_surcharge',
    'fuel_surcharge_linehaul',
    'fuel_surcharge_bobtail',
];
export default function ApproveAccessorialNextStep({ item, shipment }) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [fscAccessorials, setFscAccessorials] = useState([]);
    useEffect(() => {
        getAccessorials();
    }, [shipment]);
    const getAccessorials = async () => {
        const query = {
            shipment: shipment._id || shipment,
            shipper_status: { $in: ['pending-admin', 'pending-shipper'] },
        };
        const { data: { request: accessorials }, } = await getAccessorialRequests(query);
        const pendingFscAccessorials = accessorials.filter((a) => fscAccessorialTypes.includes(a.accessorial_type));
        const fscAccessorialIds = pendingFscAccessorials.map((accessorial) => accessorial._id);
        setFscAccessorials(fscAccessorialIds);
    };
    const handleRemoveAccessorial = (accessorialId) => {
        const updatedAccessorials = fscAccessorials.filter((a) => a !== accessorialId);
        setFscAccessorials(updatedAccessorials);
    };
    const renderIcon = () => {
        return !item.complete ? (React.createElement(ClipboardCheck, { className: "w-5 h-5" })) : (React.createElement("div", { className: getCircleButtonClass({ size: 'small', color: 'brand' }) },
            React.createElement(CheckIcon, null)));
    };
    const handleApproveAccessorials = (payload) => {
        AccessorialRequestActionCreators.approveAccessorials(payload);
        setShowModal(false);
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex justify-between text-sm text-gray-700  py-1 items-center" },
            React.createElement("span", null, t(sluggify(item.field))),
            React.createElement(CircleButton, { size: "small", disabled: item.complete, onClick: () => setShowModal(true) }, renderIcon())),
        showModal && (React.createElement(ConfirmationModal, { action: "approve_all", show: showModal, shipmentId: shipment._id, onHide: () => setShowModal(false), selectedAccessorials: fscAccessorials, onAccessorialSubmit: handleApproveAccessorials, handleAccessorialRemove: handleRemoveAccessorial }))));
}
